import { ModalSequencer } from '../../common/modal-sequencer';
import modalDescriptionFunction from './modal-sequential/modal-description-function';
import modalFirstLogin from './modal-sequential/modal-first-login';
import modalGraduationYear from './modal-sequential/modal-graduation-year';
import modalJobStatusLogin from './modal-sequential/modal-job-status-login';
import modalMessageNotification from './modal-sequential/modal-message-notification';

// モーダルを順番に表示させる
jQuery(function ($) {
    // 表示させたい順にモーダルを指定してください。DOMに定義されているものから順に表示されます。
    // (MicroModalのonCloseで次をshow。定義されていないモーダルはスキップされます。)
    const modalSequencer = new ModalSequencer([
        // 就職活動の状況
        modalJobStatusLogin,

        // 卒業予定年月に誤りがないかご確認ください
        modalGraduationYear,

        // プロフィールを充実させてあなたに合う企業からメッセージをもらおう
        modalDescriptionFunction,

        // お気に入りボタンについて・メッセージボタンについて
        modalFirstLogin,

        // 未読メッセージがあります
        modalMessageNotification,
    ]);

    // 先頭のモーダルを表示
    modalSequencer.show();
});
